import { useState, useEffect } from "react";
import { useAbVariant } from "@/hooks/useAbVariant";

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { copy, variant } = useAbVariant();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "The Experience", href: "#value" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Studio", href: "#about" },
    { label: "Pricing", href: "#pricing" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#F6F1E8]/85 backdrop-blur-md border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center"
          aria-label="Chic Wedding Photography"
        >
          <img
            src="/chic-logo.webp"
            alt="Chic Wedding Photography"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="eyebrow text-foreground/80 hover:text-foreground link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#apply"
          data-testid="nav-apply-cta"
          data-cta-variant={variant}
          className="hidden md:inline-flex items-center gap-2 bg-[#1A1A1A] text-[#F6F1E8] px-5 py-3 eyebrow rounded-none hover:bg-[#000] transition-colors"
        >
          {copy.short}
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden md:hidden eyebrow border border-foreground/40 px-3 py-2"
          aria-label="Toggle menu"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="lg:hidden md:hidden border-t border-border bg-[#F6F1E8]/95 backdrop-blur">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-serif-display text-2xl tracking-tight"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#apply"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-apply"
              data-cta-variant={variant}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#1A1A1A] text-[#F6F1E8] px-5 py-4 eyebrow"
            >
              {copy.short} →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
